import React from 'react';

/**
 * A logo component for the Daggerheart logo using the actual logo image.
 */
const IconDaggerheart = () => (
  <img 
    src="/icon-192.png" 
    alt="Daggerheart Logo" 
    className="h-6 w-6"
  />
);

export default IconDaggerheart;